(function () {
  var osInstances = new WeakMap();
  var osStatePrefix = 'os-mlo-load-more:';
  var osStateLifetime = 30 * 60 * 1000;

  function osStateKey() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    return osStatePrefix + url.pathname + '?' + url.searchParams.toString();
  }

  function osReadState() {
    try {
      var state = JSON.parse(sessionStorage.getItem(osStateKey()) || 'null');
      if (!state || Date.now() - state.updatedAt > osStateLifetime) return null;
      return state;
    } catch (error) {
      return null;
    }
  }

  function osWriteState(state) {
    try {
      sessionStorage.setItem(
        osStateKey(),
        JSON.stringify(Object.assign({}, state, { updatedAt: Date.now() }))
      );
    } catch (error) {
      // sessionStorage can be unavailable in private browsing contexts.
    }
  }

  function osProductPath(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function OSMloLoadMore(root) {
    this.root = root;
    this.grid = root.querySelector('#product-grid');
    this.loadedUrls = [];
    this.loading = false;
    this.stateKey = osStateKey();

    if (!this.grid) return;

    this.root.addEventListener('click', this.osHandleClick.bind(this));
    this.observer = new MutationObserver(this.osHandleMutation.bind(this));
    this.observer.observe(this.root, { childList: true, subtree: true });
    this.osSyncControls();
    this.osRestore();
  }

  OSMloLoadMore.prototype.osGetLoadMore = function () {
    return this.root.querySelector('[data-os-mlo-load-more]');
  };

  OSMloLoadMore.prototype.osGetButton = function () {
    return this.root.querySelector('[data-os-mlo-load-more-button]');
  };

  OSMloLoadMore.prototype.osSyncControls = function () {
    var loadMore = this.osGetLoadMore();
    var button = this.osGetButton();

    if (loadMore && button) {
      loadMore.classList.add('is-ready');
    }
  };

  OSMloLoadMore.prototype.osHandleMutation = function () {
    var nextKey = osStateKey();
    if (nextKey !== this.stateKey) {
      this.stateKey = nextKey;
      this.loadedUrls = [];
    }

    this.grid = this.root.querySelector('#product-grid');
    this.osSyncControls();
  };

  OSMloLoadMore.prototype.osHandleClick = function (event) {
    var button = event.target.closest('[data-os-mlo-load-more-button]');
    if (button && this.root.contains(button)) {
      event.preventDefault();
      this.osLoad(button.href, false);
      return;
    }

    var productLink = event.target.closest('#product-grid a[href*="/products/"]');
    if (!productLink || !this.root.contains(productLink)) return;

    osWriteState({
      loadedUrls: this.loadedUrls,
      pendingReturn: true,
      productPath: osProductPath(productLink.href),
      scrollY: window.scrollY,
    });
  };

  OSMloLoadMore.prototype.osSetLoading = function (loading) {
    var button = this.osGetButton();
    if (!button) return;

    var status = this.root.querySelector('[data-os-mlo-load-more-status]');
    var label = button.querySelector('[data-os-mlo-load-more-label]');
    button.setAttribute('aria-disabled', loading ? 'true' : 'false');
    if (label) {
      label.textContent = loading
        ? button.dataset.osLoadingLabel
        : button.dataset.osLabel;
    }
    if (status) {
      status.textContent = loading ? button.dataset.osLoadingLabel : '';
    }
  };

  OSMloLoadMore.prototype.osLoad = async function (url, restoring) {
    if (this.loading || !url || this.loadedUrls.includes(url)) return;

    this.loading = true;
    this.osSetLoading(true);

    try {
      var response = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('Load more request failed');

      var html = await response.text();
      var documentFragment = new DOMParser().parseFromString(html, 'text/html');
      var sourceRoot = documentFragment.querySelector(
        '[data-os-mlo-section-id="' + this.root.dataset.osMloSectionId + '"]'
      );
      var sourceGrid = sourceRoot
        ? sourceRoot.querySelector('#product-grid')
        : documentFragment.querySelector('#product-grid');
      var sourceButton = sourceRoot
        ? sourceRoot.querySelector('[data-os-mlo-load-more-button]')
        : documentFragment.querySelector('[data-os-mlo-load-more-button]');

      if (!sourceGrid || !this.grid) throw new Error('Product grid not found');

      Array.from(sourceGrid.children).forEach(function (item) {
        if (!item.hasAttribute('data-os-mlo-editorial-slot')) {
          this.grid.appendChild(document.importNode(item, true));
        }
      }, this);

      this.loadedUrls.push(url);
      this.osUpdateNextButton(sourceButton);

      if (!restoring) {
        osWriteState({
          loadedUrls: this.loadedUrls,
          pendingReturn: false,
          productPath: '',
          scrollY: window.scrollY,
        });
      }
    } catch (error) {
      window.location.href = url;
    } finally {
      this.loading = false;
      this.osSetLoading(false);
    }
  };

  OSMloLoadMore.prototype.osUpdateNextButton = function (sourceButton) {
    var loadMore = this.osGetLoadMore();
    var button = this.osGetButton();

    if (!sourceButton) {
      if (loadMore) loadMore.remove();
      return;
    }

    if (!button) return;

    button.href = sourceButton.href;

    var count = button.querySelector('[data-os-mlo-remaining-count]');
    var sourceCount = sourceButton.querySelector('[data-os-mlo-remaining-count]');
    if (count && sourceCount) count.textContent = sourceCount.textContent;
  };

  OSMloLoadMore.prototype.osRestore = async function () {
    var state = osReadState();
    if (!state || !state.pendingReturn || !Array.isArray(state.loadedUrls)) return;

    for (var index = 0; index < state.loadedUrls.length; index += 1) {
      await this.osLoad(state.loadedUrls[index], true);
    }

    this.loadedUrls = state.loadedUrls.slice();
    await new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(resolve);
      });
    });

    var target = Array.from(
      this.grid.querySelectorAll('[data-os-mlo-product-url]')
    ).find(function (item) {
      return osProductPath(item.dataset.osMloProductUrl) === state.productPath;
    });

    if (target) {
      target.scrollIntoView({ block: 'center' });
    } else if (Number.isFinite(state.scrollY)) {
      window.scrollTo(0, state.scrollY);
    }

    osWriteState({
      loadedUrls: this.loadedUrls,
      pendingReturn: false,
      productPath: '',
      scrollY: window.scrollY,
    });
  };

  function osInit(root) {
    if (!root || osInstances.has(root)) return;
    osInstances.set(root, new OSMloLoadMore(root));
  }

  function osBoot(scope) {
    (scope || document)
      .querySelectorAll('[data-os-mlo-load-more-root]')
      .forEach(osInit);
  }

  osBoot(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches('[data-os-mlo-load-more-root]')) osInit(node);
        osBoot(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (event) {
    osBoot(event.target);
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;

    var state = osReadState();
    if (!state || !state.pendingReturn) return;

    osWriteState({
      loadedUrls: state.loadedUrls || [],
      pendingReturn: false,
      productPath: '',
      scrollY: window.scrollY,
    });
  });
})();
